import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core'
import {DynamicCategoryLandingPageContent} from '../../../../core/content/types/category-landing-page.types'

@Component({
  selector: 'bgo-category-landing-page-content',
  templateUrl: './category-landing-page-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class CategoryLandingPageContentComponent {
  @Input() content: DynamicCategoryLandingPageContent[] = []
  @Output() reviewCtaClicked = new EventEmitter()
  @Output() howItWorksCtaClicked = new EventEmitter()
  @Output() videoSectionCtaClicked = new EventEmitter()

  @ViewChild('offeringSection') offeringSection?: ElementRef
}

interface ContentTemplateContext {
  section: DynamicCategoryLandingPageContent
  last: boolean
}

@Directive({
  selector: 'ng-template[content-template]',
  standalone: true,
})
export class ContentTemplateDirective {
  static ngTemplateContextGuard(dir: ContentTemplateDirective, ctx: unknown): ctx is ContentTemplateContext {
    return true
  }
}
